import Vue from 'vue'

export const mkLinkedItemsNames = (name1: string | undefined, name2: string | undefined): string => {
  return (name1 && name2) ? ('<br>' + name1 + ' \u2192 ' + name2) : '';
}

class NotifyService {

  posit: string = 'top';
  dur: number = 5000;
  public isHandling401: boolean = false;

  success(message: string, clear_previous = false, duration: number = this.dur, position: any = this.posit) {
    if (clear_previous) {
      Vue.$toast.clear();
    }
    Vue.$toast.open({ type: 'success', message: message, duration: duration, position: position });
  }

  error(message: string, clear_previous = false, duration: number = this.dur, position: any = this.posit) {
    if (clear_previous) {
      Vue.$toast.clear();
    }
    Vue.$toast.open({ type: 'error', message: message, duration: duration, position: position });
  }

  info(message: string, clear_previous = false, duration: number = this.dur, position: any = this.posit) {
    if (clear_previous) {
      Vue.$toast.clear();
    }
    Vue.$toast.open({type: 'info', message: message, duration: duration, position: position});
  }

  warn(message: string, clear_previous = false, duration: number = this.dur, position: any = this.posit) {
    if (clear_previous) {
      Vue.$toast.clear();
    }
    Vue.$toast.open({ type: 'warning', message: message, duration: duration, position: position });
  }
}

export default new NotifyService();
